import styled from '@emotion/styled'
import { getComponentTheme } from '../../../__styling'

export const Teaser = styled.div(({ theme }) => {
    const leadCardTheme = getComponentTheme(theme, 'card')
    return {
        width: '100%',
        fontFamily: theme.fonts.body,
        fontSize: 20,
        color: leadCardTheme.teaser.textColor,
        wordBreak: 'break-word',
    }
})
